module.exports = __webpack_public_path__ + "static/media/favicon.78568848.ico";


//////////////////
// WEBPACK FOOTER
// ./node_modules/loyal-design-system/skins/incriveis-shell/favicon.ico
// module id = 1850
// module chunks = 11